import React from "react";
import IPage from "../../interfaces/page"
import CancelComponent from "../../components/Cancel/Cancel.component";

const CancelPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <CancelComponent></CancelComponent>;
};

export default CancelPage;
